<template>
  <b-modal
    v-model="shown"
    :title="title"
    ok-title="Upload"
    ok-variant="primary"
    cancel-title="Cancel"
    centered
    :busy="busy"
    @ok.prevent="submit"
    @hidden="reset"
  >
    <p v-if="description" class="mb-1">{{ description }}</p>
    <b-form-group label="File">
      <b-form-file
        v-model="file"
        placeholder="Choose a file…"
        drop-placeholder="Drop the file here…"
        :state="touched && !file ? false : null"
      />
      <small v-if="touched && !file" class="text-danger">Please choose a file.</small>
    </b-form-group>
    <b-form-group label="Note (optional)" class="mb-0">
      <b-form-input v-model="note" placeholder="Shown with the file" />
    </b-form-group>
  </b-modal>
</template>

<script>
// Picks a file (and an optional note) for the internal "upload on behalf" and
// "upload shared document" flows. Emits `upload` with `{file, note}`; the parent
// closes it by setting `value` to false once the request has finished.
export default {
  name: "UploadModal",

  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "Upload document" },
    description: { type: String, default: "" },
    busy: { type: Boolean, default: false },
  },

  data() {
    return {
      file: null,
      note: "",
      touched: false,
    };
  },

  computed: {
    shown: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    submit() {
      this.touched = true;
      if (!this.file) return;
      this.$emit("upload", { file: this.file, note: this.note.trim() });
    },

    reset() {
      this.file = null;
      this.note = "";
      this.touched = false;
    },
  },
};
</script>
